<template>
  <div class="main">
    <div class="top">
      <div class="title">
        <span class="t-l">微课</span>
        <span class="t-r flex-row">
          <span  @click="orderRelease" type="primary" class="has-ep">发布</span>
<!--          <span  @click="goStudent" type="primary" class="has-ep">学生端预览</span>-->
        </span>
      </div>
      <div class="left">
        <div class="content" >
          <div class="bgc" v-for="(item,index) in video_list" :key="index">
            <div style="text-align: left;font-size: 16px;color: #000000FF;font-weight: 400;margin-left: 50px">{{item.name}}</div>
            <div class="message" v-if="item&&item.videoPath.split('.')[1]=='mp4'">
                <video style="max-height: 260px;outline-style: none;object-fit: fill;" controlslist="nodownload" :disablePictureInPicture="true" :src="resBaseVideo+'/'+item.videoPath" :poster="item.videoPhotoCover&&item.videoPhotoCover!=null?resBasePath+item.videoPhotoCover:videoPhoto" controls></video>
            </div>
            <div class="message" v-if="item&&item.videoPath.split('.')[1]=='m3u8'">
                <ts-video style="max-height: 260px;outline-style: none;object-fit: fill;" :poster="item.videoPhotoCover&&item.videoPhotoCover!=null?resBasePath+item.videoPhotoCover:videoPhoto" :vPath="resBaseVideo+item.videoPath"> </ts-video>
            </div>

<!--            <div class="caozuo">-->
<!--              <a-button class="delete" @click="deleted(item.id)" icon="delete">删除</a-button>-->
<!--            </div>-->
            <div class="task-status">
              <div class="status-l">
                <span class="staTitle">状态:</span>
                <span class="staMain">{{ format.permission(item.permission) }}</span>
              </div>
              <div class="status-r">
                <a-button class="edit" @click="editTask(item)" icon="form">编辑</a-button>
                <a-button class="delete" @click="deleted(item.id)" icon="delete">删除</a-button>
              </div>
          </div>
          </div>
          <div class="bgc" v-if="video_list.length==0"> <a-empty style="padding:80px"/></div>
        </div>
      </div>
        <div class="fun">
          <div class="button">
            <a-button class="add" @click="add" icon="plus">添加</a-button>
          </div>
        </div>
<!--      <div class="right">-->
<!--        <div class="order">-->
<!--          <div class="studentLook">-->
<!--            <a-button class="orderMes" @click="orderRelease" type="primary">发布</a-button>-->
<!--            <a-tooltip placement="top" :title="tipMess">-->
<!--              <a-button class="studentView" type="primary" @click="goStudent"><img class="logo" src="@/assets/imgs/logo2.png" />学生端预览</a-button>-->
<!--            </a-tooltip>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
    </div>
      <!---编辑--->
      <div v-if="editVisible">
        <a-modal v-model="editVisible" title="编辑微课视频" width="400px" footer="">
          <div class="editdalog">
            <a-spin class="load" v-show="loading" tip="上传中..." />
            <div> <span >视频标题：</span> <a-input style="width: 180px;"  v-model="newTitle" placeholder="请输入微课标题"></a-input></div>
            <div class="uploadImg">
              <span >视频状态：</span>
              <a-select :default-value="newPermissionText"  style="width:180px;" @change="editSelectChange">
                <a-select-option v-for="(item, index) in selectOpen" :key="index" :value="item.key">
                  {{item.value}}
                </a-select-option>
              </a-select>
            </div>
            <div class="editVideo" v-show="!(this.newVideoPath === '')" ref="editVideo">
              <video class="editvideoPlay" style="outline-style: none;" controlslist="nodownload"
                     :disablePictureInPicture="true" :src="resBaseVideo + '/' +newVideoPath"
                     controls="controls"
                     :poster="videoPhoto"></video>
              <img class="del" @click="editdelVideo" src="../../../assets/image/27.png" alt="" />
            </div>
            <div class="clearfix flex-row justify-between">
              <a-upload action=""
                        list-type="picture-card"
                        :show-upload-list="false"
                        @preview="handlePreview"
                        :before-upload="beforeUploadEdit"
              >
                <div class="ant-upload-text">重新上传</div>
              </a-upload>
              <a-button class="sureButton" @click="editOk">确定</a-button>
              <a-modal :visible="previewVisible"
                       :footer="null"
                       @cancel="handleCancel">
                <img alt="example"
                     style="width: 100%"
                     :src="previewImage" />
              </a-modal>
            </div>

          </div>
        </a-modal>
      </div>
    <!--add start-->
    <div v-if="addVisible">
      <a-modal v-model="addVisible" title="添加微课视频" width="400px" footer="">
        <div class="dalog">
          <a-spin class="load" v-show="loading" tip="上传中..." />
          <div> <span>视频标题：</span> <a-input style="width: 180px;" v-model="videoTitle"></a-input></div>
          <div class="uploadImg">
            <span>视频状态：</span>
            <a-select  default-value="私有" style="width:180px;" @change="addSelectChange">
              <a-select-option v-for="(item, index) in selectOpen" :key="index" :value="item.key">
                {{item.value}}
              </a-select-option>
            </a-select>
            <!-- <a-button class="sureButton" @click="addHandleOk">确定</a-button> -->
          </div>
          <div class="clearfix flex-row justify-between" >
                <a-upload action=""
                          list-type="picture-card"
                          :show-upload-list="false"
                          @preview="handlePreview"
                          :before-upload="beforeUploadAdd"
                          >
                  <div class="ant-upload-text">上传</div>
                </a-upload>
                <a-modal :visible="previewVisible"
                        :footer="null"
                        @cancel="handleCancel">
                  <img alt="example"
                      style="width: 100%"
                      :src="previewImage" />
                </a-modal>
              </div>
          <!-- <div>
            <a-textarea class="mess" :auto-size="{ minRows: 6, maxRows: 12 }" />
          </div> -->

        </div>
      </a-modal>
    </div>
    <!--add end-->
    <!---学生端预览弹窗--->
    <a-modal class="classNumber" v-model="releaseStu" width="440px" title="" footer="">
      <div class="classTop">
        <a-radio-group  @change="onChangeStu">
          <div class="classSelect" v-for="(item, index) in classData" :key="index">
            <a-radio :value="item.id">{{item.className}}</a-radio>
          </div>
        </a-radio-group>
        <div class="classBot">
          <a-button class="cancelButton"
                    @click="releaseStu = false">取消</a-button>
          <a-button class="classSureButton"
                    @click="classSureStu">确定</a-button>
        </div>
      </div>
    </a-modal>
    <!---学生端预览结束弹窗--->
    <a-modal class="classNumber"
             v-model="release"
             width="440px"
             title=""
             footer="">
      <div class="classTop">
        <a-checkbox-group @change="checkClass">
          <div class="classSelect"
               v-for="(item, index) in classData"
               :key="index">
            <a-checkbox :value="item.id">{{item.className}}</a-checkbox>
          </div>
        </a-checkbox-group>
        <div class="classBot">
          <a-button class="cancelButton"
                    @click="release = false">取消</a-button>
          <a-button class="classSureButton"
                    :disabled="disabledClass ==false"
                    @click="classSure">确定</a-button>
        </div>
      </div>
    </a-modal>
    <a-modal title="提示"
             :visible="visible"
             :confirm-loading="confirmLoading"
             @ok="handleOk"
             @cancel="handleCancel1">
      <p>{{ ModalText }}</p>
    </a-modal>
    <a-modal title="提示"
             :visible="visibles"
             :confirm-loading="confirmLoading"
             @ok="handleOk1"
             @cancel="handleCancels">
      <p>{{ ModalTexts }}</p>
    </a-modal>
    <div v-if="lookVis">
      <a-modal  class="classNumber" v-model="lookVis" width="440px" title="发布" footer="">
        <div class="classTop">
          <a-radio-group @change="lookCheckClass">
            <div class="classSelect" v-for="(item, index) in classData" :key="index">
              <a-radio :value="item.id">{{item.className}}</a-radio>
            </div>
          </a-radio-group>
          <div class="classBot">
            <a-button class="cancelButton" @click="lookVis = false">取消</a-button>
            <a-button class="classSureButton" @click="lookSure">确定</a-button>
          </div>
        </div>
      </a-modal>
    </div>
      <a-modal title="预览" class="classNumber" v-model="look" width="1100px" @cancel="()=>{look = false}" footer="">
          <div class="video-content" v-for="(item,index) in viewMess" :key="index">
            <div class="video-bgc" >
              <ts-new :videos="item.videoList"></ts-new>
            </div>
          </div>
          <div v-if="viewMess==null||viewMess.length==0">
            <a-empty style="margin-top:40px"/>
          </div>
      </a-modal>
  </div>
</template>

<script>
import axios from 'axios'
import tsNew from '../components/tsNew.vue'
import format from '../../../utils/format.js'
export default {
  name: 'SmallClass',
  components: {
    tsNew
  },
  created () {

  },
  data () {
    return {
      resBaseVideo: this.$resBaseVideo,
      format,
      visible: false,
      visibles: false,
      confirmLoading: false,
      ModalText: '您确认删除吗',
      ModalTexts: '请您先添加微课',
      addVisible: false,
      classData: [], // 班级信息列表
      orderParam: [], // 选择的发布班级
      disabledClass: false,
      release: false, // 发布
      prepareData: [],
      previewVisible: false,
      previewImage: '',
      videoList: [],
      releaseStu: false, // xueshengduanyulan
      addParam: { // 学前准备添加参数集合
        styleId: localStorage.getItem('styleId'),
        bookId: localStorage.getItem('syzg-bookId'),
        videoPath: [],
        teacherId: this.$getUserInfo().id, // 教师id
        videoPhoto: require('../../../assets/imgs/video.png'),
        permission: 2,
        name: ''
      },
      video_list: [],
      videoPhoto: require('../../../assets/imgs/video.png'),
      videoTitle: '',
      id: '',
      token: '',
      loading: false,
      look: false,
      lookVis: false,
      lookClassData: '',
      viewMess:[],
      tipMess: '请您发布成功后再预览！',
      editVisible: false, // 编辑
      editMess: {},
      newTitle: '',
      newpermission: 2,
      newPermissionText: '私有',
      newVideoPath: '',
      selectOpen: [
        { value: '公开', key: '1' },
        { value: '私有', key: '2' },
      ],
    }
  },

  mounted () {
    this.token = localStorage.getItem('access_token')
    this.getClassNum()
    this.getList()
  },
  methods: {
    editdelVideo () {
      this.newVideoPath = ''
    },
    goStudent(){
      this.lookVis = true
    },
    lookCheckClass(val){
      this.lookClassData = val.target.value
    },
    lookSure(){
      if(this.lookClassData==''){
        this.$message.warning('请选择要预览的班级')
      }else{
        const param = {
        styleId: localStorage.getItem('styleId'),
        userId: this.$getUserInfo().id,
        classId: this.lookClassData
      }
      const _this = this
      this.$fetch({
          url: _this.$baseUrl + 'ebook/teacher/microLecture/getTeacherMicroLecturePreview',
          body: param
      }).loading(
          () => (_this.loading = true),
          () => (_this.loading = false)
        ).done(res => {
          if(res&&res.success){
              _this.viewMess = res.resultData
              _this.lookVis = false
              _this.look = true
          }
        })
      }
    },
    // 保存确定
    addHandleOk () {
      this.$fetch({
        url: this.$baseUrl + 'ebook/teacher/microLecture/add',
        body: this.addParam
      }).done(res => {
        this.addVisible = false
        this.getList()
      })
    },
    editCancel() {
      this.editVisible = false
    },
    //编辑确定
    editOk() {
      if (this.newTitle === '') {
        this.$message.warning('请输入标题')
        return
      }
      if (this.newVideoPath === '') {
        this.$message.warning('请上传视频')
        return
      }
      const param = {
        userId: this.userId,
        name: this.newTitle,
        access_token: this.token,
        id: this.editMess.id,
        styleId: localStorage.getItem('styleId'),
        teacherId: this.$getUserInfo().id, // 教师id
        videoPath: this.newVideoPath,
        permission: this.newpermission
      }
      this.$fetch({
        url: this.$baseUrl + 'ebook/teacher/microLecture/add',
        body: param
      }).done(res => {
        this.$message.success('编辑成功')
        this.getList()
        this.editVisible = false
      })
    },
    getList () {
      this.$fetch({
        url: this.$baseUrl + 'ebook/teacher/microLecture/getTeacherMicroLecture',
        body: this.addParam
      }).done(res => {
        if (res && res.success && res.resultCode === 0) {
          this.video_list = res.resultData
        }
      })
    },
    add () {
      this.addVisible = true
    },
    deleted (id) {
      this.visible = true
      this.id = id
    },
    editTask (item) {
      console.log(item)
      this.editMess = JSON.parse(JSON.stringify(item))
      console.log( this.editMess)
      this.newTitle = this.editMess.name
      this.newVideoPath = this.editMess.videoPath
      this.newpermission = this.editMess.permission
      this.newPermissionText = this.newpermission === 2 ? '私有' : '公开'
      //  this.editvideoTrans = this.editMess.videoPath
      console.log(this.newVideoPath)
      console.log(this.newTitle)
      console.log(this.newPermissionText)
      this.editVisible = true
    },
    orderRelease () { // 发布
      if (this.classData != null && this.classData.length > 0) {
        this.release = true
      } else {
        this.$message.warning('暂无发布班级信息')
      }
    },
    checkClass (val) {
      this.orderParam = val
      if (this.orderParam.length > 0) {
        this.disabledClass = true
      } else {
        this.disabledClass = false
      }
    },
    getClassNum () {
      this.$fetch({
        url: this.$baseUrl + 'ebook/class/v3/common/getSimpleClaList',
        body: { userId: this.$getUserInfo().id }
      }).done(res => {
        if (res && res.success && res.resultCode === '0') {
          this.classData = res.resultData
        }
      })
    },
    handleOk (e) {
      this.visible = false
      this.confirmLoading = false
      this.$fetch({
        url: this.$baseUrl + 'ebook/teacher/microLecture/deleteById',
        body: { id: this.id }
      }).done(res => {
        this.getList()
      })
    },
    handleCancel1 (e) {
      this.visible = false
    },
    handleCancels (e) {
      this.visibles = false
    },
    handleOk1 () {
      this.visibles = false
    },
    addSelectChange (e) {
      this.addParam.permission = e
    },
    editSelectChange (e) {
      this.newpermission = e
    },
    classSure () {
      const param = {
        styleId: localStorage.getItem('styleId'),
        teacherId: this.$getUserInfo().id,
        classIds: this.orderParam
      }
      this.$fetch({
        url: this.$baseUrl + 'ebook/teacher/push/publishToClass',
        body: param
      }).loading(
        () => (this.loading = true),
        () => (this.loading = false)
      ).done(res => {
        if (res && res.success && res.resultCode === 0) {
          this.$message.success('发布成功')
          this.release = false
        } else {
          this.$message.error(res.resultMessage)
        }
      })
    },
    classSureStu () {
      if (!this.classStuId) {
        this.$message.warning('请您选择班级预览')
        return false
      } else {
        this.releaseStu = false
        window.open(this.$studentUrl + '#/books/learning-pre/' + localStorage.getItem('styleId'))
      }
    },
    onChangeStu (e) {
      this.classStuId = e.target.value
    },
    handleCancel () {
      this.previewVisible = false
    },
    async handlePreview (file) {
      if (!file.url && !file.preview) {
        file.preview = await getBase64(file.originFileObj)
      }
      this.previewImage = file.url || file.preview
      this.previewVisible = true
    },
    beforeUploadAdd (file) {
      const size = file.size/1024/1024
      if (size > 300) {
        this.$message.error('300M以内的视频')
        this.addVisible = true
      } else if (this.videoTitle === '') {
        this.$message.error('请输入视频标题')
        this.addVisible = true
      } else {
        this.loading = true
        const formData = new FormData()
        formData.append('file', file)
        formData.append('fileName',this.videoTitle || file.name)
        formData.append('customDir', 'hytc_ebook_server/file')
        formData.append('access_token', this.token || '')
        const _this = this
        // 上传图片方法
        axios({
          url: _this.$uploadUrl,
          method: 'post',
          data: formData,
          headers: { 'Content-Type': 'multipart/form-data' }
        }).then(res => {
          if (res && res.status === 200) {
            const result = /\.[^\.]+/.exec(res.data.url)[0]
            if (result == '.mp4') {
              _this.videoList.push({
                id: res.data.id,
                url: res.data.url
              })
              _this.videoList.map(item => {
                _this.addParam.videoPath = item.url
                _this.addParam.name = this.videoTitle || file.name
              })
              this.addVisible = false
              _this.loading = false
              this.addHandleOk()
            } else {
              _this.$message.error('请上传mp4格式')
              _this.loading = false
            }
          }
        })
      }
    },
    beforeUploadEdit (file) {
      const size = file.size/1024/1024
      if (size > 300) {
        this.$message.error('300M以内的视频')
        this.editVisible = true
      }else {
        this.loading = true
        const formData = new FormData()
        formData.append('file', file)
        formData.append('fileName',this.newTitle || file.name)
        formData.append('customDir', 'hytc_ebook_server/file')
        formData.append('access_token', this.token || '')
        const _this = this
        // 上传图片方法
        axios({
          url: _this.$uploadUrl,
          method: 'post',
          data: formData,
          headers: { 'Content-Type': 'multipart/form-data' }
        }).then(res => {
          if (res && res.status === 200) {
            const result = /\.[^\.]+/.exec(res.data.url)[0]
            if (result == '.mp4') {
              _this.videoList.push({
                id: res.data.id,
                url: res.data.url
              })
              _this.videoList.map(item => {
                _this.newVideoPath = item.url
                _this.newName = this.videoTitle || file.name
              })
              _this.loading = false
            } else {
              _this.$message.error('请上传mp4格式')
              _this.loading = false
            }
          }
        })
      }
    }
  },
}
</script>
<style lang="less" scoped>
/deep/ .ant-upload-list-item-actions a{
  display: none;
}
.main {
  //width: 1240px;
 // padding-right: 20px;
  margin: 0px 20px;

  .load {
    position: absolute;
    top: 45%;
    left: 50%;
    transform: translate(50%, 50%);
    z-index: 99;
  }
  .top {
    // height:400px;
   // display: flex;
    background: #fff;
    padding: 20px 30px;
    margin-top: 20px;
    border-radius: 12px;
    height: calc(100vh - 185px);
    // max-height: 600px;
    overflow-y: auto;

    .title{
      display: flex;
      margin: 0 auto 20px auto;
      .t-l{
        color: #333;
        font-size: 16px;
        font-weight: 600;
      }
      .t-r{
        margin-left: auto;
        align-content: center;
        text-align: center;
        font-size: 14px;
        color: #d7d7d7;
        .use-his{
          color: @primary-color;
          cursor: pointer;
          // margin-right: 15px;
          text-align: center;
        }
        .pre{
          color: @primary-color;
          cursor: pointer;
          text-align: center;
          width: 4.45vw;
          height: 1.67vw;
        }
        .has-ep {
          width: 80px;
          text-align: center;
          line-height: 24px;
          background: @primary-color;
          border-radius: 2px;
          border: 1px solid @primary-color;
          color: #fff;
          margin-left: 20px;
        }
        .add-pre{
          display: inline-block;
          width: 80px;
          height: 24px;
          line-height: 24px;
          background: @primary-color;
          border-radius: 2px;
          color: #fff;
          text-align: center;
          margin-left: 20px;
          cursor: pointer;
          .add-img{
            width: 16px;
            height: 16px;
          }
          .add-text{
            margin-left: 5px;
          }
        }
      }
    }
    .left {
      flex: 20;
      border-radius: 12px;
      min-height: 370px;
      background: #fff;
      .content {
        width: 100%;
        //height: 600px;
        overflow-y: auto;
        .bgc {
          background: #F1F0F0;
          min-height: 350px;
          border-radius: 10px;
          padding: 20px;
          margin-bottom: 20px;
          // margin-top: 30px;
          // .status {
          //   padding: 20px 50px 0px 50px;
          //   .staTitle {
          //     font-size: 22px;
          //     color: #bdbdbd;
          //   }
          //   .staMain {
          //     font-size: 22px;
          //     color: #000;
          //     margin-left: 30px;
          //   }
          // }
          .message {
           // max-width: 800px;
            margin: 0 auto;
            padding: 20px 50px;
            margin-top: 10px;
            text-align: left;
          }
          .caozuo{
             text-align: right;
            height: 60px;
            line-height: 60px;
            .delete {
              width: 120px;
              height: 40px;
              color: #db5647;
              font-size: 16px;
            }
          }
          .task-status {
            //text-align: right;
            //height: 60px;
            //line-height: 60px;
            display: flex;
            border-top: 1px solid #DBDBDB;
            padding-top: 20px;
            padding-bottom: 20px;
            padding-right: 20px;

            .status-l {
              font-size: 14px;
              margin-left: 20px;
              .staTitle {
                font-size: 14px;
                color: #867D7BFF;
              }

              .staMain {
                font-size: 14px;
                color: @primary-color;
                margin-left: 10px;
              }
            }
            .status-r {
              margin-left: auto;
              span {
                color: @primary-color;
                cursor: pointer;
                display: inline-block;
                width: 80px;
                height: 24px;
                line-height: 24px;
                text-align: center;
                border-radius: 2px;
                border: 1px solid @primary-color;
                margin-left: 8px;
              }
              .no-e{
                width: 80px;
                text-align: center;
                line-height: 24px;
                background: #F1F0F0;
                border-radius: 2px;
                border: 1px solid #bdbdbd;
                color: #bdbdbd;
              }
              .has-e{
                width: 80px;
                text-align: center;
                line-height: 24px;
                background: #F1F0F0;
                border-radius: 2px;
                border: 1px solid @primary-color;
                color: @primary-color;
              }
              .studentView {
                width: 120px;
                height: 40px;
                border-radius: 8px;
                margin-top: 20px;
                margin-left: -30px;
                background: #f8f8f8;
                color: #000;
                border: none;

                .logo {
                  width: 20px;
                  height: 20px;
                  margin-top: -4px;
                  margin-right: 8px;
                  margin-left: -10px;
                }
              }
            }

            .operate{
              text-align: right;
            }

            .status {
              padding: 20px 20px 0px 20px;

              .staTitle {
                font-size: 14px;
                color: #867D7BFF;
              }

              .staMain {
                font-size: 14px;
                color: @primary-color;
                margin-left: 10px;
              }
            }
            .edit {
              width: 80px;
              text-align: center;
              line-height: 24px;
              background: #F1F0F0;
              border-radius: 2px;
              border: 1px solid @primary-color;
              color: @primary-color;
              margin-right: 20px;
            }

            .delete {
              width: 80px;
              text-align: center;
              line-height: 24px;
              background: #F1F0F0;
              border-radius: 2px;
              border: 1px solid #fa5542;
              color: #db5647;
            }
          }
        }
      }
    }
    .right {
      flex: 4;
      margin-left: 20px;
      .order {
        height: 160px;
        background: #fff;
        border-radius: 12px;
        .studentLook {
          flex: 4;
          height: 160px;
          background: #fff;
          margin-left: 30px;
          border-radius: 12px;
          text-align: center;
          .orderMes {
            width: 120px;
            height: 40px;
            border-radius: 8px;
            background-image: linear-gradient(122deg, #ff8d46 0%, #fa5542 100%);
            margin-top: 20px;
            margin-left: -30px;
          }
          .studentView {
            width: 120px;
            height: 40px;
            border-radius: 8px;
            margin-top: 20px;
            margin-left: -30px;
            background: #f8f8f8;
            color: #000;
            border: none;
            .logo {
              width: 20px;
              height: 20px;
              margin-top: -4px;
              margin-right: 8px;
              margin-left: -10px;
            }
          }
        }
      }
    }
  }
  .fun {
    margin: 0px 0px 20px 0px;
    display: flex;
    .button {
      flex: 20;
      .add {
        width: 120px;
        height: 40px;
        color: #a3af90;
        font-size: 16px;
        //margin-left: 20px;
      }
      // .delete {
      //   width: 120px;
      //   height: 40px;
      //   color: #db5647;
      //   font-size: 16px;
      //   float: right;
      // }
    }
  }
}
.dalog,
.editdalog {
  // padding: 25px 0 0 120px;
  text-align: center;
  .mess {
    width: 1000px;
    height: 150px;
    margin-top: 15px;
    border: 1px solid #e1d9c2;
    background-color: #f8f8f8;
    padding: 20px 30px 0px 30px;
    p {
      color: #000;
      letter-spacing: 0px;
      font-size: 16px;
      line-height: 32px;
    }
  }
  .uploadImg {
    margin-top: 20px;
    .upload {
      width: 100px;
      height: 30px;
      color: #a3af90;
      margin-right: 20px;
    }
  }
  .editVideo{
    position: relative;
   // width: 33%;
    height: 150px;
    display: inline-block;
    text-align: center;
    margin-top: 25px;

    .editvideoPlay {
     // width: 290px;
      height: 150px;
    }

    .del {
      display: none;
      width: 20px;
      height: 20px;
      z-index: 99;
      position: absolute;
      right: 16px;
      top: 6px;
    }

    &:hover {
      .del {
        display: block;
        cursor: pointer;
      }
    }
  }
  .clearfix{

    .sureButton {
      width: 110px;
      height: 38px;
      background: @primary-color;
      color: #fff;
      float: right;
      margin-top: 25px;
      margin-left: 40px
    }
    .ant-upload-text {
      color: #fff;
    }
    /deep/.ant-upload-list-picture .ant-upload-list-item-error,
    .ant-upload-list-picture-card .ant-upload-list-item-error {
      border-color: #fff;
    }
    /deep/.ant-upload-picture-card-wrapper {
      width: 10px;
    }
  }
}

.classNumber {
  min-height: 260px;
  .classTop {
    .classSelect {
      height: 40px;
      line-height: 40px;
    }
  }
  .classBot {
    height: 40px;
    line-height: 40px;
    margin-top: 10px;
    .cancelButton {
      width: 180px;
    }
    .classSureButton {
      width: 180px;
      background: @primary-color;
      color: #fff;
      margin-left: 10px;
    }
  }
}
/deep/.ant-checkbox + span {
  font-size: 20px;
  color: #fff;
  font-size: 18px;
  font-family: PingFangSC-Regular;
  padding-left: 20px;
}
  /deep/.ant-upload.ant-upload-select-picture-card {
    display: table;
    float: left;
    //width: 120px;
    height: 10px;
    margin-right: 8px;
    margin-bottom: 8px;
    text-align: center;
    vertical-align: top;
    background-color: @primary-color;
    border: 1px dashed #d9d9d9;
    border-radius: 8px;
    cursor: pointer;
    transition: border-color 0.3s ease;
   // margin-left: 125px;
    margin-top: 25px;
}
.video-content{
  margin-top: 15px;
  .video-bgc{

  }
}

.task-top{
  height: 30px;
  line-height: 30px;
  display: flex;
  .text{
    margin-top: 10px;
  }
  .xing{
    color: #fa5542;
    font-size: 14px;
  }
}
.remove-footer{
  margin-top: 20px;
  display: flex;
  padding: 0 150px;
  .cancel{
    height: 30px;
    line-height: 30px;
    text-align: center;
    border-radius: 4px;
    margin-left:35%;
  }
  .remove-on{
    height: 30px;
    line-height: 20px;
    text-align: center;
    margin-left: 5%;
    border-radius: 4px;
    padding: 5px 10px;
  }
}
.add-video-btn{
  width: 120px;
  height: 30px;
  line-height: 30px;
  color: #fff;
  text-align: center;
  font-size: 16px;
  background: @primary-color;
  border-radius: 2px;
  margin-top: 25px;
  cursor: pointer;
}
.img-list{
  display: flex;
  margin-top :25px;
  flex-wrap: wrap;
  position: relative;
  .loading{
    position: absolute;
    width: 100px;
    height: 50px;
    left: 50%;
    top: 20%;
    margin-left: -50px;
    z-index: 9999999;
  }
  .img-detail{
    width: 150px;
    height: 100px;
    position: relative;
    margin-right: 8px;
    margin-top: 5px;
    .img{
      width: 150px;
      height: 100px;
      margin-left: 5px;
    }
    .del{
      width: 18px;
      height: 18px;
      position:absolute;
      right: 0px;
      top: 0px;
      display: none;
    }
    &:hover{
      display: block;
      .del{
        width: 18px;
        height: 18px;
        position:absolute;
        right: 0px;
        top: 10px;
        display: block;
        cursor: pointer;
      }
    }
  }
}
/deep/.ant-checkbox+span {
  font-size: 20px;
  color: #040506;
  font-size: 18px;
  font-family: PingFangSC-Regular;
  padding-left: 10px;
}
.publish-task {
  width: 300px;
  margin: 0 auto;
  color: #000;
  font-size: 16px;

  .publish-top {
    height: 30px;

    .l {
      text-indent: 15px;
    }

    .r {
      height: 30px;
    }
  }

  .publish-bot {
    .l {
      margin-top: 12px;
    }

    .classSelect {
      margin-top: 12px;
      font-size: 14px;
      color: #797979;
    }
  }
}
.del-m {
  width: 200px;
  margin: auto;
  text-align: center;
  .del-t {
    font-size: 16px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #DB5647;
    line-height: 24px;
  }

  .del-s {
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #040506;
    line-height: 24px;
  }


}
.f-del {
  display: flex;
  width: 180px;
  margin: 20px auto 0;
  div {
    width: 80px;
    height: 24px;
    line-height: 24px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    border-radius: 2px;
    text-align: center;
    margin: auto;
    cursor: pointer;
  }

  .f-c {
    background: #FFFFFF;
    border: 1px solid #DBD1CD;
    color: #867D7B;
  }

  .f-s {
    background: @primary-color;
    color: #fff;
    margin-left: 20px;
  }
}
</style>
